import React, { type FC } from 'react';

import SpaceY from '../../../components/SpaceY';
import { GRAY_COLOR_200, MAX_WIDTH_639PX } from '../../../utils/common';
import { Z_INDEX } from '../../../utils/common/zIndex';
import useClientMediaQuery from '../../../utils/hook/useClientMediaQuery';
import { useRouterQuery } from '../../../utils/hook/useRouterQuery';

interface MissionTabMenuProps {
  handleTabToSourcing: (tab?: 0 | 1) => void;
}
const MissionTabMenu: FC<MissionTabMenuProps> = ({ handleTabToSourcing }) => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });

  const { query } = useRouterQuery<{ tabIndex?: 1 }>();
  const tabIndex = query.tabIndex ?? 0;

  const tabs = [
    { id: 0, title: '미션' },
    { id: 1, title: '소싱철학' },
  ] as const;

  if (isMobile)
    return (
      <>
        <SpaceY height={8} />
        <div
          className="sticky-below-gnb sticky border-b border-gray-200 bg-white"
          style={{ zIndex: Z_INDEX.MISSION_TAB_MENU }}
        >
          <ul className="relative grid w-full grid-cols-2 items-center text-center">
            {tabs.map(({ id, title }) => (
              <li key={id}>
                <button
                  onClick={() => handleTabToSourcing(id)}
                  className={`pt-8px pb-16px text-16px ${
                    tabIndex === id
                      ? 'font-semibold text-brand-1'
                      : 'text-gray-800'
                  }`}
                  type="button"
                >
                  {title}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </>
    );

  return (
    <div
      className="sticky-below-gnb sticky bg-white"
      style={{
        borderBottom: `1px solid ${GRAY_COLOR_200}`,
        zIndex: Z_INDEX.MISSION_TAB_MENU,
      }}
    >
      <div className={`mx-auto max-w-screen-lg px-16px`}>
        <ul
          className="relative grid grid-cols-2 items-center text-center sm:mx-auto"
          style={{ width: 366 }}
        >
          {tabs.map(({ id, title }) => (
            <li key={id}>
              <button
                onClick={() => handleTabToSourcing(id)}
                className={`pt-8px pb-16px text-16px sm:py-16px ${
                  tabIndex === id
                    ? 'font-semibold text-brand-1'
                    : 'text-gray-800'
                }`}
                type="button"
              >
                {title}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MissionTabMenu;
